module.exports = __webpack_public_path__ + "static/img/cadrage_bg_2.40b6de3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cadrage_bg_2.png
// module id = o+X/
// module chunks = 1